export const LS_AUTH = "AUTH";
